import * as React from "react";
import { useSearch, useLocation } from "wouter";
import { apiFetch } from "@/lib/api.js";
import { useAuth } from "@/contexts/AuthContext.js";

export default function VerifyEmailPage() {
  const search = useSearch();
  const [, navigate] = useLocation();
  const { refresh } = useAuth();
  const [status, setStatus] = React.useState<"verifying" | "success" | "error">("verifying");
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    const token = new URLSearchParams(search).get("token");
    if (!token) { setStatus("error"); setError("Missing verification token"); return; }
    apiFetch("/api/auth/verify-email", { method: "POST", body: JSON.stringify({ token }) })
      .then(() => { setStatus("success"); refresh(); })
      .catch((err) => { setStatus("error"); setError(err.message); });
  }, [search, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper p-4">
      <div className="w-full max-w-sm bg-card rounded-lg border border-clay-border p-8 text-center">
        <h1 className="text-2xl font-semibold text-amethyst-ink mb-4 font-headline tracking-[-0.01em]">Email Verification</h1>
        {status === "verifying" && <p className="text-sm text-faint">Verifying your email...</p>}
        {status === "success" && (
          <>
            <p className="text-sm text-success-text bg-success-wash rounded-md px-3 py-2 mb-4">Your email has been verified!</p>
            <button onClick={() => navigate("/")} className="px-6 py-2.5 rounded-md bg-primary text-white text-sm font-medium hover:bg-amethyst-ink transition-colors">Go to Dashboard</button>
          </>
        )}
        {status === "error" && (
          <>
            <p className="text-sm text-error-text bg-error-wash rounded-md px-3 py-2 mb-4">{error || "Verification failed"}</p>
            <button onClick={() => navigate("/")} className="px-6 py-2.5 rounded-md bg-primary text-white text-sm font-medium hover:bg-amethyst-ink transition-colors">Go to Dashboard</button>
          </>
        )}
      </div>
    </div>
  );
}
